import { CookieManager } from "@Utilities/CookieManager";

export class Purim
{
	private readonly IsraelCountryId = "1023";
	private VisitorCookie = CookieManager.Cookies.Visitor;
	private readonly NegativeMessage = "Item cannot be shipped to Israel because we do not have a licensing agreement for your country.";
	private readonly PositiveMessage = "Item does ship to Israel. Duty free up to $150.";

	constructor()
	{
		this.SetShippingMessage();
	}

	private SetShippingMessage = (): void =>
	{
		const userCountryId = this.GetCountry();

		if (userCountryId !== null && userCountryId.length > 0 && userCountryId == this.IsraelCountryId)
		{
			const purimDiv = document.querySelector(".purim");
			const purimRestricted = document.querySelector("input[name='PurimRestricted']") as HTMLInputElement;

			if (purimDiv !== null && purimRestricted !== null)
			{
				purimDiv.classList.remove("d-none");

				if (purimRestricted.value == "True")
				{
					purimDiv.textContent = this.NegativeMessage;
				}
				else
				{
					purimDiv.textContent = this.PositiveMessage;
				}
			}
		}
	}

	private GetCountry = (): string =>
	{
		const countryIDValue = CookieManager.GetCookie(this.VisitorCookie.Key, this.VisitorCookie.CountryID);
		return countryIDValue;
	}
}